import { useEffect, useMemo, useState } from 'react';

export default function useOfferCountdown(expiresAt) {
  const targetDate = useMemo(() => {
    if (!expiresAt) {
      return null;
    }

    const parsed = new Date(expiresAt);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }, [expiresAt]);

  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    setNow(Date.now());
  }, [expiresAt]);

  useEffect(() => {
    if (!targetDate) {
      return undefined;
    }

    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return useMemo(() => {
    if (!targetDate) {
      return {
        value: '',
        label: '',
        status: 'idle',
        remainingMs: null,
      };
    }

    const remainingMs = targetDate.getTime() - now;
    if (remainingMs <= 0) {
      return {
        value: 'Ended',
        label: 'Offer ended',
        status: 'ended',
        remainingMs: 0,
      };
    }

    const totalSeconds = Math.floor(remainingMs / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    let value = '';
    if (days > 0) {
      value = `${days}d ${hours}h`;
    } else if (hours > 0) {
      value = `${hours}h ${minutes.toString().padStart(2, '0')}m`;
    } else if (minutes > 0) {
      value = `${minutes}m ${seconds.toString().padStart(2, '0')}s`;
    } else {
      value = `${seconds}s`;
    }

    let status = 'running';
    if (remainingMs <= 30 * 60 * 1000) {
      status = 'final';
    } else if (remainingMs <= 2 * 60 * 60 * 1000) {
      status = 'warning';
    }

    return {
      value,
      label: `Offer ends in ${value}`,
      status,
      remainingMs,
    };
  }, [now, targetDate]);
}
